import React from 'react';
import { Layout, Menu, Button, Row, Col, Card, Statistic } from 'antd';
import { AppstoreOutlined, DatabaseOutlined, DashboardOutlined, ShoppingCartOutlined, UsergroupAddOutlined, CheckCircleOutlined, StockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../../components/AppLayout';

const { Header, Content, Sider } = Layout;

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <AppLayout>
      <h2 style={{ marginBottom: '1rem' }}>ERP Overview</h2>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <Card bordered={false} style={{ borderRadius: 12 }}>
            <Statistic
              title="Active Work Orders"
              value={42}
              prefix={<CheckCircleOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card bordered={false} style={{ borderRadius: 12 }}>
            <Statistic
              title="Inventory Items"
              value={128}
              prefix={<DatabaseOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card bordered={false} style={{ borderRadius: 12 }}>
            <Statistic
              title="Pending Deliveries"
              value={15}
              prefix={<ShoppingCartOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card bordered={false} style={{ borderRadius: 12 }}>
            <Statistic
              title="Employees Assigned"
              value={9}
              prefix={<UsergroupAddOutlined />}
            />
          </Card>
        </Col>
      </Row>
    </AppLayout>
  );
};

export default Dashboard;
